export default __webpack_public_path__ + "static/media/s1-project-sm.8155e894.jpg";